import React from "react"
import loadable from '@loadable/component'
import Testimonial from "../organisms/Testimonial"
import DotList from "../molecules/DotList"
import { Desktop, Mobile } from '../util/breakpoints'
import 'react-multi-carousel/lib/styles.css'

const MultiCarousel = loadable(() => import( 'react-multi-carousel' ))
const Carousel = loadable(() => import( 'react-responsive-carousel' ), { resolveComponent: (components) => components.Carousel} )

export default ({ testimonials }) => {
  if(!testimonials)
    return null

  const testimonialElements = testimonials.map((item, index) =>
    <Testimonial key={ index }
                 video={ item.video }
                 image={ item.image }
                 label={ item.label }
                 quote={ item.quote }
                 author={ item.author }
                 youtube={ item.youtubeID }
                 youtubeText={ item.youtubeText }
                 link={ item.link }
    />
  )

  return (
    <section className={ "u-section-spacing" }>
      <div className="o-full-carousel">
        <Desktop>
          <MultiCarousel
            containerClasss="o-carousel"
            dotListClass="m-dot-list"
            arrows={ false }
            showDots={ testimonials.length > 1 }
            customDot={ <DotList /> }
            draggable
            swipeable
            partialVisibility
            autoPlaySpeed={ 2000 }
            responsive={{
              desktop: {
                breakpoint: { max: 3000, min: 0 },
                items: 1,
              }
            }}
          >
            { testimonialElements }
          </MultiCarousel>
        </Desktop>
        <Mobile>
          <div className="o-carousel">
            <Carousel
              showThumbs={ false }
              centerMode={ false }
              centerSlidePercentage={ 90 }
              showArrows={ false }
              showStatus={ false }
              renderIndicator={(onClickHandler, isSelected, index, label) => {
                return (
                  <li>
                    <button
                      className={ "m-dot-list__item" + ( isSelected ? " m-dot-list__item--active" : "" ) }
                      aria-label={"Move carousel to " + index }
                      onClick={ () => onClickHandler() }
                    />
                  </li>
                )
              }}
            >
              { testimonialElements }
            </Carousel>
          </div>
        </Mobile>
      </div>
    </section>
  )
}
